export enum Permission {
  None = 0x00000,
  Read = 0x00001,
  Create = 0x00010,
  Update = 0x00100,
  Delete = 0x01000,
  Execute = 0x10000,
}
